{
    "nav": {
        "dashboard": "تجربة العملاء",
        "surveys": "الاستبيانات",
        "distributions": "الإرسال",
        "journeys": "الرحلات",
        "verbatims": "آراء العملاء",
        "actions": "إجراءات التحسين"
    },
    "dashboard": {
        "title": "تجربة العملاء",
        "subtitle": "المؤشرات والمحركات وما يُتخذ حيالها",
        "index": "المؤشر",
        "nps": "مؤشر صافي الترويج",
        "csat": "الرضا",
        "ces": "جهد العميل",
        "base": "{{count}} رداً",
        "unreliable": "عدد الردود أقل من أن يُعتمد عليه",
        "promoters": "مروّجون",
        "passives": "محايدون",
        "detractors": "منتقدون",
        "responses": "الردود",
        "invited": "المدعوون",
        "response_rate": "نسبة الاستجابة",
        "awaiting_follow_up": "منتقدون لم تتم متابعتهم",
        "vs_previous": "مقارنة بالفترة السابقة",
        "no_comparison": "لا توجد فترة قابلة للمقارنة",
        "trend": "الاتجاه",
        "by_channel": "حسب القناة",
        "drivers": "ما يحرّك المؤشر",
        "driver_impact": "الأثر",
        "driver_mentions": "{{count}} إشارة",
        "driver_explanation": "من ذكروا هذا الموضوع سجّلوا فرقاً قدره {{points}} نقطة عمن لم يذكروه.",
        "emerging": "مواضيع متصاعدة",
        "emerging_new": "جديد",
        "emerging_multiple": "×{{multiple}} مقارنة بالأساس",
        "no_data": "لا توجد ردود تطابق هذه المرشّحات.",
        "map": "حسب المحافظة",
        "branches": "حسب الفرع",
        "filters": "المرشّحات",
        "survey": "الاستبيان",
        "all_surveys": "كل الاستبيانات",
        "channel": "القناة",
        "all_channels": "كل القنوات",
        "from": "من",
        "to": "إلى",
        "apply": "تطبيق"
    },
    "survey": {
        "title": "الاستبيانات",
        "code": "الرمز",
        "name": "الاسم",
        "type": "النوع",
        "status": "الحالة",
        "channels": "القنوات",
        "questions": "الأسئلة",
        "responses": "الردود",
        "new": "استبيان جديد",
        "edit": "تعديل",
        "save": "حفظ الاستبيان",
        "preview": "معاينة",
        "preview_on": "معاينة على",
        "untranslated": "{{count}} من الأسئلة تنقصها ترجمة",
        "translated": "كل الأسئلة مكتوبة باللغتين",
        "name_en": "الاسم (بالإنجليزية)",
        "name_ar": "الاسم (بالعربية)",
        "intro_en": "المقدمة (بالإنجليزية)",
        "intro_ar": "المقدمة (بالعربية)",
        "thanks_en": "رسالة الشكر (بالإنجليزية)",
        "thanks_ar": "رسالة الشكر (بالعربية)",
        "expiry_days": "صلاحية الدعوة (أيام)",
        "estimated_minutes": "الدقائق المتوقعة",
        "allows_anonymous": "قبول الردود دون تعريف",
        "add_question": "إضافة سؤال",
        "question_key": "المفتاح",
        "question_type": "النوع",
        "text_en": "السؤال (بالإنجليزية)",
        "text_ar": "السؤال (بالعربية)",
        "required": "إلزامي",
        "is_index": "هذا هو سؤال المؤشر",
        "is_verbatim": "تحليل هذا التعليق للمواضيع",
        "scale": "المقياس",
        "scale_fixed": "محدد بحسب نوع السؤال",
        "options": "الخيارات",
        "add_option": "إضافة خيار",
        "option_value": "القيمة",
        "label_en": "النص (بالإنجليزية)",
        "label_ar": "النص (بالعربية)",
        "rules": "التفرّع",
        "add_rule": "إضافة قاعدة",
        "rule_when": "عندما تكون الإجابة",
        "rule_then": "عندها",
        "rule_target": "انتقل إلى",
        "remove": "حذف",
        "statuses": {
            "draft": "مسودة",
            "active": "نشط",
            "paused": "متوقف",
            "archived": "مؤرشف"
        },
        "types": {
            "nps": "صافي الترويج",
            "csat": "الرضا",
            "ces": "جهد العميل",
            "custom": "مخصص"
        }
    },
    "distribution": {
        "title": "الإرسال",
        "new": "إرسال جديد",
        "name": "الاسم",
        "survey": "الاستبيان",
        "channel": "القناة",
        "segment": "شريحة الجمهور",
        "all_customers": "الجميع",
        "scheduled_for": "وقت الإرسال",
        "closes_at": "وقت الإغلاق",
        "quota": "الحد الأقصى للدعوات",
        "reminders": "التذكيرات",
        "reminder_after": "التذكير بعد (أيام)",
        "start": "بدء",
        "invited": "المدعوون",
        "responded": "المستجيبون",
        "suppressed": "لم يُراسلوا",
        "response_rate": "نسبة الاستجابة",
        "status": "الحالة",
        "qr_posters": "ملصقات رمز الاستجابة",
        "create_poster": "إنشاء ملصق",
        "poster_branch": "الفرع",
        "poster_placement": "مكان العرض",
        "poster_created": "تم إنشاء الملصق",
        "poster_url": "رابط الملصق",
        "print": "طباعة الملصق",
        "scan_me": "امسح الرمز وأخبرنا برأيك",
        "statuses": {
            "draft": "مسودة",
            "scheduled": "مجدول",
            "running": "جارٍ الإرسال",
            "completed": "منتهٍ",
            "cancelled": "ملغى"
        }
    },
    "journey": {
        "title": "الرحلات",
        "new": "رحلة جديدة",
        "name": "الاسم",
        "event": "عند حدوث",
        "survey": "أرسل هذا الاستبيان",
        "channel": "عبر",
        "delay": "الانتظار (دقائق)",
        "delay_help": "سؤال العميل وهو ما زال منزعجاً يعطي إجابة مختلفة عن سؤاله في اليوم التالي.",
        "conditions": "فقط عندما",
        "add_condition": "إضافة شرط",
        "field": "الحقل",
        "operator": "يكون",
        "value": "القيمة",
        "respect_suppression": "احترام قواعد الإيقاف",
        "active": "نشطة",
        "fired": "عملت {{count}} مرة",
        "never_fired": "لم تعمل بعد",
        "save": "حفظ الرحلة",
        "immediately": "فوراً"
    },
    "verbatims": {
        "title": "ما قاله العملاء",
        "filter_theme": "الموضوع",
        "all_themes": "كل المواضيع",
        "filter_band": "الفئة",
        "all_bands": "كل الفئات",
        "evidence": "طابق على",
        "no_comments": "لا توجد تعليقات تطابق هذه المرشّحات.",
        "follow_up": "تسجيل المتابعة",
        "followed_up": "تمت المتابعة",
        "needs_follow_up": "بحاجة إلى متابعة",
        "anonymous": "دون تعريف",
        "raise_action": "رفع إجراء"
    },
    "actions": {
        "title": "إجراءات التحسين",
        "new": "إجراء جديد",
        "action_title": "ما سيُنفَّذ",
        "description": "التفاصيل",
        "owner": "المسؤول",
        "branch": "الفرع",
        "theme": "الموضوع",
        "due": "تاريخ الاستحقاق",
        "priority": "الأولوية",
        "measure_after": "القياس بعد (أيام)",
        "save": "حفظ الإجراء",
        "baseline": "المؤشر قبل",
        "outcome": "المؤشر بعد",
        "movement": "التغيّر",
        "not_measured": "لم يُقَس بعد",
        "overdue": "متأخر",
        "columns": {
            "proposed": "مقترح",
            "in_progress": "قيد التنفيذ",
            "blocked": "متوقف",
            "done": "منجز",
            "cancelled": "ملغى"
        }
    },
    "public": {
        "loading": "جارٍ التحميل…",
        "expired": "لم يعد هذا الرابط صالحاً.",
        "submit": "إرسال",
        "next": "التالي",
        "back": "السابق",
        "progress": "السؤال {{current}} من {{total}}",
        "required": "هذا السؤال يحتاج إلى إجابة.",
        "thanks_title": "شكراً لك",
        "powered": "بنك التنمية",
        "choose": "اختر واحداً",
        "choose_many": "اختر ما ينطبق",
        "your_answer": "إجابتك",
        "yes": "نعم",
        "no": "لا"
    },
    "bands": {
        "promoter": "مروّج",
        "passive": "محايد",
        "detractor": "منتقد"
    },
    "channels": {
        "web": "نموذج إلكتروني",
        "email": "بريد إلكتروني",
        "sms": "رسالة نصية",
        "whatsapp": "واتساب",
        "qr": "رمز الاستجابة السريعة",
        "voice": "مكالمة آلية",
        "agent": "بمساعدة موظف"
    },
    "simulators": {
        "title": "القنوات الأخرى",
        "subtitle": "واتساب، ومكالمة آلية، واستبيان يقرأه موظف — وكلها تعمل عبر نفس الواجهة التي يستدعيها جهاز العميل.",
        "start": "بدء",
        "idle": "اختر استبياناً وابدأ لترى ما ترسله هذه القناة فعلياً.",
        "keypad": "إدخال من لوحة المفاتيح",
        "completed": "اكتمل — تم تسجيل الرد."
    },
    "question_types": {
        "nps": "صافي الترويج (٠–١٠)",
        "csat": "الرضا",
        "ces": "الجهد",
        "rating": "تقييم",
        "scale": "مقياس",
        "single_choice": "اختيار واحد",
        "multi_choice": "اختيار متعدد",
        "text": "نص قصير",
        "long_text": "تعليق",
        "boolean": "نعم أو لا",
        "date": "تاريخ",
        "number": "رقم"
    },
    "operators": {
        "equals": "يساوي",
        "not_equals": "لا يساوي",
        "less_than": "أقل من",
        "greater_than": "أكبر من",
        "in": "أحد",
        "contains": "يحتوي",
        "answered": "تمت الإجابة عليه",
        "skipped": "تم تخطيه",
        "is_null": "فارغ",
        "not_null": "غير فارغ"
    },
    "rule_actions": {
        "skip_to": "انتقل إلى",
        "end_survey": "إنهاء الاستبيان",
        "show": "أظهر",
        "hide": "أخفِ"
    },
    "embed": {
        "title": "كود التضمين",
        "generate": "إنشاء",
        "iframe": "الصق هذا في الصفحة",
        "link": "أو ضع رابطاً إليه",
        "link_text": "أخبرنا برأيك",
        "frame_title": "استبيان رأي العملاء",
        "placement": "مكان ظهوره",
        "placement_example": "مثال: بعد صفحة طلب التمويل",
        "height": "الارتفاع (بكسل)",
        "anonymous_only": "يمكن تضمين الاستبيانات التي تقبل الردود دون تعريف فقط — فالصفحة العامة لا تعرف العميل لتربط الرد به.",
        "reuse_warning": "يبقى هذا الرابط صالحاً ويمكن الرد عليه أكثر من مرة، وهو ما يحتاجه الاستبيان المُضمَّن. لا ترسله إلى عميل بعينه؛ استخدم إرسالاً لذلك."
    }
}
